module.exports = __webpack_public_path__ + "static/media/Steve.ceacb9ab.png";